import styled from 'styled-components';

export const PopupGeneral = styled.div`
  bottom: 20px;
  right: 20px;
  width: 400px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  animation: dropdown 1s ease-out forwards;
  opacity: 0;
  @media (max-width: 450px) {
    width: 100%;
  }

  @keyframes dropdown {
    from {
      opacity: 0;
      transform: translateX(100px);
    }
    to {
      opacity: 1;
      transform: translateX(0px);
    }
  }
`;

export const PopupContent = styled.div`
  display: grid;
  grid-template-columns: 50px minmax(200px, 1fr);
  box-shadow: var(--box-shadow);
  align-items: center;
  justify-content: space-between;
  background: ${({ type }) => `var(--${type})`};
  padding: 20px;
  color: #ffffff;
  margin-bottom: 10px;
  border-radius: 4px;
`;

export const TitlePopup = styled.p`
  max-width: 45ch;
  color: #ffffff;
  text-transform: uppercase;
  align-self: center;
  font-family: 'GothamBold';
  font-size: 1.4rem;
  line-height: 1.8rem;
`;
